module.exports = "<app-quotation [type]=\"'generate'\"></app-quotation>"